import { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";

export default function LaunchBanner() {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    setDismissed(localStorage.getItem("heylpmate_banner_dismissed") === "1");
  }, []);
  if (dismissed) return null;
  return (
    <div
      data-testid="launch-banner"
      className="w-full text-white text-sm font-semibold"
      style={{ background: "linear-gradient(90deg, #00604A 0%, #2E4890 55%, #F26522 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="w-4 h-4 shrink-0 text-[#FFD9B0]" />
          <span className="truncate">
            <b>Live now:</b> Pune · Indore · Mumbai (Thane, Kalyan, Bhiwandi). Other Mumbai areas — <b>pre-booking open</b>.
          </span>
        </div>
        <button
          data-testid="launch-banner-close"
          aria-label="Dismiss banner"
          onClick={() => {
            localStorage.setItem("heylpmate_banner_dismissed", "1");
            setDismissed(true);
          }}
          className="shrink-0 opacity-80 hover:opacity-100"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
